import Paziente from "../home";
import Pazienti from "../../pazienti";

const routes = [
    { name: "PazienteView", path: "/paziente/view/:id", component: Paziente.PazienteHome, meta: { title: "Paziente View" } },
    { name: "PazienteEdit", path: "/paziente/edit/:id", component: Pazienti.PazientiEdit, meta: { title: "pazienti.lblTitle" } },
];

export default routes;
